import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ce0e443")

_pushScopeId("data-v-2ce0e443")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Создание предложения", -1)
const _hoisted_2 = {
  key: 0,
  class: "order-create-modal__tripType-wraper"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "avia-tarif-modal__title" }, "Данные предложения", -1)
const _hoisted_5 = { class: "order-create-modal-customer" }
const _hoisted_6 = { class: "order-create-modal-customer__item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Название", -1)
const _hoisted_8 = { class: "order-create-modal-customer__item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Компания", -1)
const _hoisted_10 = { class: "order-create-modal-customer__item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Контракт", -1)
const _hoisted_12 = { class: "order-create-modal-customer__item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Инициатор", -1)
const _hoisted_14 = {
  key: 2,
  class: "order-create-modal-tabs"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", null, "Заказы", -1)
const _hoisted_16 = { class: "blockNewTiket" }
const _hoisted_17 = { class: "order-create-modal-newsletter" }
const _hoisted_18 = {
  key: 0,
  class: "order-create-modal-newsletter__title"
}
const _hoisted_19 = { class: "order-create-modal-newsletter__controls" }
const _hoisted_20 = { class: "p-field-checkbox" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "newsletter" }, "Включить рассылку", -1)
const _hoisted_22 = { class: "order-create-modal-newsletter__buttons-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_InputText = _resolveComponent("InputText")
  const _component_order_avia_ticket = _resolveComponent("order-avia-ticket")
  const _component_rail_tiket_small = _resolveComponent("rail-tiket-small")
  const _component_hotels_modal_card = _resolveComponent("hotels-modal-card")
  const _component_transfer_card = _resolveComponent("transfer-card")
  const _component_free_card = _resolveComponent("free-card")
  const _component_order_details = _resolveComponent("order-details")
  const _component_email_list = _resolveComponent("email-list")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.localDisplay,
      "onUpdate:visible": _cache[17] || (_cache[17] = $event => (_ctx.localDisplay = $event)),
      dismissableMask: true,
      class: "p-dialog--hotels",
      modal: true
    }, {
      header: _withId(() => [
        _hoisted_1
      ]),
      default: _withId(() => [
        (!_ctx.newOrder)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_AutoComplete, {
                minLength: 3,
                modelValue: _ctx.selectedTrip,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.selectedTrip = $event)),
                placeholder: "Выберите командировку",
                field: "name",
                suggestions: _ctx.lists.trips,
                loading: _ctx.isLoading,
                onComplete: _cache[2] || (_cache[2] = $event => (_ctx.asyncFind($event, 'trips', _ctx.ActionTypesConstants.GET_TRIP))),
                onItemSelect: _cache[3] || (_cache[3] = $event => (_ctx.setData($event, 'businessTripId'))),
                dropdown: true,
                disabled: _ctx.newOrder
              }, null, 8, ["modelValue", "suggestions", "loading", "disabled"]),
              _createVNode("button", {
                class: "order-create-modal__newTrip-btn",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.createNewOrder(...args)))
              }, " Новая командировка ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.newOrder)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("ul", _hoisted_5, [
                _createVNode("li", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.defaultOrder.businessTrip.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.defaultOrder.businessTrip.name = $event)),
                    placeholder: "Введите название"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("li", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_AutoComplete, {
                    minLength: 3,
                    modelValue: _ctx.selectedClient,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.selectedClient = $event)),
                    placeholder: "Выберите клиента",
                    field: "entityName",
                    suggestions: _ctx.lists.clients,
                    onComplete: _cache[7] || (_cache[7] = $event => (
                _ctx.asyncFind($event, 'clients', _ctx.ActionTypesConstants.GET_CLIENT)
              )),
                    onItemSelect: _cache[8] || (_cache[8] = $event => (_ctx.setData($event, 'clientId'))),
                    disabled: !_ctx.defaultOrder.businessTrip.name,
                    dropdown: true
                  }, null, 8, ["modelValue", "suggestions", "disabled"])
                ]),
                _createVNode("li", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedContract,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.selectedContract = $event)),
                    placeholder: "Выберите контракт",
                    minLength: 3,
                    field: "entityName",
                    suggestions: _ctx.lists.contracts,
                    onComplete: _cache[10] || (_cache[10] = $event => (
                _ctx.asyncFind(
                  $event,
                  'contracts',
                  _ctx.ActionTypesConstants.GET_CONTRACT
                )
              )),
                    onItemSelect: _cache[11] || (_cache[11] = $event => (_ctx.setData($event, 'contractId'))),
                    disabled: !_ctx.defaultOrder.businessTrip.clientId,
                    dropdown: true
                  }, null, 8, ["modelValue", "suggestions", "disabled"])
                ]),
                _createVNode("li", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedInitiator,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.selectedInitiator = $event)),
                    placeholder: "Выберите инициатора",
                    minLength: 3,
                    field: "entityName",
                    suggestions: _ctx.lists.initiators,
                    onComplete: _cache[13] || (_cache[13] = $event => (
                _ctx.asyncFind(
                  $event,
                  'initiators',
                  _ctx.ActionTypesConstants.GET_INITIATOR
                )
              )),
                    onItemSelect: _cache[14] || (_cache[14] = $event => (_ctx.setData($event, 'initiatorId'))),
                    disabled: 
                !_ctx.defaultOrder.businessTrip.clientId ||
                  !_ctx.defaultOrder.businessTrip.contractId
              ,
                    dropdown: true
                  }, null, 8, ["modelValue", "suggestions", "disabled"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTrip || _ctx.newOrder)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_order_details, {
                tickets: _ctx.tickets,
                tripId: _ctx.defaultOrder.businessTripId,
                hasNew: true,
                onlyNew: _ctx.newOrder
              }, {
                new: _withId(() => [
                  _createVNode("div", _hoisted_16, [
                    (_ctx.isAvia)
                      ? (_openBlock(), _createBlock(_component_order_avia_ticket, {
                          key: 0,
                          keyActive: _ctx.keyActive
                        }, null, 8, ["keyActive"]))
                      : _createCommentVNode("", true),
                    (_ctx.isRail)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.railOffer, (train) => {
                          return (_openBlock(), _createBlock(_component_rail_tiket_small, {
                            key: train.numberTrain,
                            item: train
                          }, null, 8, ["item"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("", true),
                    (_ctx.isHotel)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.hotelRooms, (room) => {
                          return (_openBlock(), _createBlock(_component_hotels_modal_card, {
                            key: room.uniqueAccessCode,
                            room: room
                          }, null, 8, ["room"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("", true),
                    (_ctx.isService)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                          (_ctx.isService && !_ctx.isFree)
                            ? (_openBlock(), _createBlock(_component_transfer_card, {
                                key: 0,
                                item: _ctx.dataSend
                              }, null, 8, ["item"]))
                            : _createCommentVNode("", true),
                          (_ctx.isFree)
                            ? (_openBlock(), _createBlock(_component_free_card, {
                                key: 1,
                                item: _ctx.dataSend
                              }, null, 8, ["item"]))
                            : _createCommentVNode("", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["tickets", "tripId", "onlyNew"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_17, [
          (_ctx.defaultOrder.isSend)
            ? (_openBlock(), _createBlock("h3", _hoisted_18, " Рассылка "))
            : _createCommentVNode("", true),
          (_ctx.defaultOrder.isSend)
            ? (_openBlock(), _createBlock(_component_email_list, {
                key: 1,
                onSetEmails: _ctx.setEmail,
                emails: _ctx.defaultOrder.emailList,
                onAddEmail: _ctx.addEmail
              }, null, 8, ["onSetEmails", "emails", "onAddEmail"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_Checkbox, {
                id: "newsletter",
                modelValue: _ctx.defaultOrder.isSend,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (_ctx.defaultOrder.isSend = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_21
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("button", {
                class: "order-create-modal-newsletter__btnAccept",
                onClick: _cache[16] || (_cache[16] = _withModifiers((...args) => (_ctx.sendOrder(...args)), ["prevent"])),
                disabled: !_ctx.isValid
              }, " Создать ", 8, ["disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
})